import {
  NavigationProp,
  ParamListBase,
  RouteProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import { useMemo } from 'react';
import { View, Text, Pressable } from 'react-native';

import useSuperiorNavbar, { NAVBAR_ITEMS } from './helpers/useSuperiorNavbar';

type RouteParams = { screen?: string; path?: string; [key: string]: string | undefined };

const SuperiorNavbar = () => {
  const navigation = useNavigation<NavigationProp<ParamListBase>>();
  const route = useRoute<RouteProp<ParamListBase, string>>();
  const routeParams = useMemo(() => route?.params as RouteParams, [route?.params]);
  const hasSuperiorNavbar = useSuperiorNavbar(route);

  const isHomePage = routeParams?.screen === 'Home' && routeParams?.path === '/';

  if (!hasSuperiorNavbar) return null;

  return (
    <View
      style={{
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: 'transparent',
        justifyContent: 'space-between',
        backgroundColor: '#070D31',
        width: '100%',
      }}>
      {NAVBAR_ITEMS.map((item) => {
        const isScreenMatched = item.screen === route.name;
        const areParamsMatched =
          JSON.stringify(item?.params || {}) === JSON.stringify(route?.params || {});

        const isSelected =
          (isScreenMatched && areParamsMatched) || (item.name === 'Home' && isHomePage);

        if (!item?.label) return;

        return (
          <Pressable
            key={item.name}
            onPress={() => navigation.navigate(item.screen, item.params)}
            style={{
              height: 40,
              borderRadius: 0,
              borderBottomWidth: 3,
              borderColor: isSelected ? '#7A8CFF' : 'transparent',
              backgroundColor: "#070D31",
              paddingHorizontal: 20,
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Text
              style={{
                fontFamily: 'system-ui',
                fontSize: 16,
                fontWeight: '600',
                color: isSelected ? '#7A8CFF' : '#FFFFFF',
              }}>
              {item.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};

export default SuperiorNavbar;
